import FormTextArea from '../Form/FormTextArea';

export default function FreeTextQuestion({
  question,
  value,                 // string — current text
  onChange,              // (newValue: string) => void
  name,                  // optional override
  required = false,
  disabled = false,
  placeholder = '',
  rows = 5,
  maxLength,             // optional
}) {
  const fieldName = name ?? `question_${question.id}_free_text`;

  return (
    <div>
      <div className="mb-6">
        <h3 className="h4">{question.title}</h3>
        {question.subtitle ? (
          <p className="prose mt-2">{question.subtitle}</p>
        ) : null}
      </div>

      <div>
        {/* If you already have a FormTextArea component, use it here */}
        <FormTextArea
          name={fieldName}
          value={value ?? ''}                // keep controlled
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          rows={rows}
          disabled={disabled}
          required={required}
          maxLength={maxLength}
        />
      </div>
    </div>
  );
}
